import React, { useCallback, useMemo, useRef, useEffect, useState } from 'react'
import { AgGridReact } from 'ag-grid-react'
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'
import { ArrowDownToLine } from 'lucide-react'
import { Tooltip } from 'react-tooltip'

export default function DataTable(props) {
    const gridRef = useRef()
    const [loading, setLoading] = useState(true)

    const defaultColDef = useMemo(() => ({
        resizable: true,
    }), [])

    const paginationNumberFormatter = useCallback((params) => {
        return params.value.toLocaleString()
    }, [])

    const onFirstDataRendered = useCallback((params) => {
        gridRef.current.api.sizeColumnsToFit()
        handleOverlay(params.api)
    }, [])

    // Handle overlay visibility
    const handleOverlay = (api) => {
        if (!props.rowData) {
            api.showLoadingOverlay()
        } else if (props.rowData.length === 0) {
            api.showNoRowsOverlay()
        } else {
            api.hideOverlay()
        }
    }

    // React to data changes dynamically
    useEffect(() => {
        if (gridRef.current?.api) {
            handleOverlay(gridRef.current.api)
        }
    }, [props.rowData])

    const onPageSizeChanged = useCallback(() => {
        const value = document.getElementById('page-size').value
        gridRef.current.api.setGridOption('paginationPageSize', Number(value))
    }, [])

    const onFilterTextBoxChanged = useCallback(() => {
        gridRef.current.api.setQuickFilter(
            document.getElementById('filter-text-box').value
        )
    }, [])

    const onBtnExport = useCallback(() => {
        gridRef.current.api.exportDataAsCsv()
    }, [])

    const onSelectionChanged = useCallback(() => {
        const selectedData = gridRef.current.api.getSelectedRows()
        props.value(props.field, selectedData)
    }, [])

    return (
        <>
            <div className="d-flex justify-content-between align-items-center">
                <div className='data-table-extensions-filter'>
                    <input
                        type="text"
                        id="filter-text-box"
                        placeholder="Search"
                        onInput={onFilterTextBoxChanged}
                        className="form-control config_filed"
                    />
                </div>
                <div className="d-flex align-items-center">
                    <label className="form-label form_label mb-0">Page Size</label>
                    <select
                        className="form-select config_filed ms-2"
                        onChange={onPageSizeChanged}
                        id="page-size"
                        style={{ width: '12vh' }}
                    >
                        <option value="10">10</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="500">500</option>
                    </select>
                    <button
                        className='btn config_filed ms-1'
                        onClick={onBtnExport}
                        data-tooltip-id='excel'
                        data-tooltip-content="Excel Download"
                        data-tooltip-place="bottom"
                    >
                        <ArrowDownToLine size={25} style={{ cursor: 'pointer', color: 'rgb(108, 197, 219)' }} />
                    </button>
                    <Tooltip id='excel' className='bg-info tooltip_msg' />
                </div>
            </div>

            <div className="ag-theme-alpine mt-2"
                style={{ height: props?.height || '60vh', width: '100%' }}>
                <AgGridReact
                    ref={gridRef}
                    rowData={props.rowData || []}
                    columnDefs={props.columnDefs || []}
                    defaultColDef={defaultColDef}
                    pagination={true}
                    paginationPageSize={10}
                    paginationNumberFormatter={paginationNumberFormatter}
                    onFirstDataRendered={onFirstDataRendered}
                    rowHeight={props.rowHeight || undefined}
                    rowSelection={props.check || undefined}
                    suppressRowClickSelection={props.selection ? true : undefined}
                    onSelectionChanged={props.selection ? onSelectionChanged : undefined}
                    overlayLoadingTemplate={
                        `<span class="ag-overlay-loading-center" style="color:#42c9c4; font-weight:600;">Loading...</span>`
                    }
                    overlayNoRowsTemplate={
                        `<span class="ag-overlay-loading-center" style="color:#999; font-weight:600;">No Data Found</span>`
                    }
                />
            </div>
        </>
    )
}
